import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState } from 'react';
import { css } from 'emotion';
import { textSans } from '@guardian/src-foundations/typography';
import { text } from '@guardian/src-foundations/palette';
import { space } from '@guardian/src-foundations';
import { stringifyFileBase64 } from '../../lib/stringifyFileBase64';
import { FieldLabel } from './FieldLabel';
const fileUploadInputStyles = css `
	padding-top: 10px;
	padding-bottom: 10px;
`;
const errorMessagesStyles = css `
	padding-top: ${space[2]}px;
	color: ${text.error};
	${textSans.small({ fontWeight: 'bold' })};
`;
export const FileUpload = ({ formField, formData, setFormData }) => {
    const [error, setError] = useState('');
    const onSelectFile = async (event) => {
        if (event.target.files && event.target.files[0]) {
            setError('');
            try {
                const stringifiedFile = await stringifyFileBase64(event.target.files[0]);
                setFormData({
                    ...formData,
                    [formField.id]: stringifiedFile,
                });
            }
            catch (e) {
                setError('Sorry there was a problem with the file you uploaded above. Check the size and type. We only accept images, pdfs and .doc or .docx files');
            }
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(FieldLabel, { formField: formField }, void 0),
            _jsx("input", { "data-testid": `form-field-${formField.id}`, className: fileUploadInputStyles, type: "file", accept: "image/*, .pdf", required: formField.required, onChange: onSelectFile }, void 0),
            _jsx("p", { children: "We accept images and pdfs. Maximum total file size: 6MB" }, void 0),
            error && _jsx("div", Object.assign({ className: errorMessagesStyles }, { children: error }), void 0)] }, void 0));
};
